export default __webpack_public_path__ + "static/media/396.469808d1.jpg";